import React, { useState } from 'react';
import {
  Box, Button, Typography, Alert, CircularProgress,
  Paper
} from '@mui/material';
import { CloudUpload } from '@mui/icons-material';
import { contractService } from '../services/api';

const ContractUpload = ({ onEmployeeExtracted, onPreviewUrlReady, compact=false, previewHeight=420 }) => {
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState('');
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setError('');
      setSuccess(false);
      // Create blob preview URL and notify parent for inline iframe preview
      const blobUrl = URL.createObjectURL(selectedFile);
      setPreviewUrl(blobUrl);
      onPreviewUrlReady?.(blobUrl);
    }
  };

  const handleUpload = async () => {
    if (!file) return;

    setUploading(true);
    setError('');

    try {
      const extractedData = await contractService.extractFromFile(file);
      setSuccess(true);
      onEmployeeExtracted(extractedData);
    } catch (error) {
      setError('Error processing contract file');
      console.error('Upload error:', error);
    } finally {
      setUploading(false);
    }
  };

  return (
    <Paper sx={{ p: compact ? 2 : 3, mb: compact ? 2 : 3 }}>
      {!compact && (
        <Typography variant="h6" gutterBottom>
          Upload Contract Document
        </Typography>
      )}

      <Box sx={{ mb: 2 }}>
        <input
          accept="image/*,.pdf"
          style={{ display: 'none' }}
          id="contract-file-input"
          type="file"
          onChange={handleFileChange}
        />
        <label htmlFor="contract-file-input">
          <Button
            variant="outlined"
            component="span"
            startIcon={<CloudUpload />}
          >
            Choose File
          </Button>
        </label>
        {file && (
          <Typography variant="body2" sx={{ mt: 1 }}>
            Selected: {file.name}
          </Typography>
        )}
      </Box>

      {previewUrl && (
        <Box sx={{ mt:2, border:'1px solid #ddd', height: previewHeight, borderRadius: 1, overflow:'hidden' }}>
          <iframe title="contract-preview" src={previewUrl} style={{ width:'100%', height:'100%', border:0 }} />
        </Box>
      )}

      {file && (
        <Button
          variant="contained"
          onClick={handleUpload}
          disabled={uploading}
          startIcon={uploading && <CircularProgress size={20} />}
          sx={{ mt: 2 }}
        >
          {uploading ? 'Processing...' : 'Extract Contract Data'}
        </Button>
      )}

      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}

      {success && (
        <Alert severity="success" sx={{ mt: 2 }}>
          Contract data extracted successfully! Form fields have been populated.
        </Alert>
      )}
    </Paper>
  );
};

export default ContractUpload;




